import { createFeatureSelector, createSelector } from "@ngrx/store";
import { AppSettings } from "src/components/shared-components/class/general-classes/app-settings";
import {
    ScenarioCommandsEntry,
    ScenariosCommandsState,
} from "../reducers/scenario-commands.reducer";

/**
 * Feature selector for the scenarios commands
 */
export const scenariosCommandsFeature =
    createFeatureSelector<ScenariosCommandsState>(
        AppSettings.KEY_SCENARIOS_COMMANDS
    );

/**
 * Parametric selector returning the commands entry for a given scenario id
 */
export const scenarioCommandsByIdSelector = (idScenario: number) =>
    createSelector(
        scenariosCommandsFeature,
        (state: ScenariosCommandsState): ScenarioCommandsEntry =>
            state?.[idScenario]
    );

/**
 * Parametric selector for the HTTP error code of the last commands API call
 * for a given scenario (-1 means no error)
 */
export const scenarioCommandsErrorCodeByIdSelector = (idScenario: number) =>
    createSelector(
        scenarioCommandsByIdSelector(idScenario),
        (entry: ScenarioCommandsEntry) => entry?.errorCode ?? -1
    );
